import { render, staticRenderFns } from "./PleatinglistoverviewPage.vue?vue&type=template&id=3a83bf26"
import script from "./PleatinglistoverviewPage.vue?vue&type=script&lang=js"
export * from "./PleatinglistoverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports